if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class Header extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
        this.header = this.closest('.header');
        this.isOverlay = this.dataset.overlay === 'true';
        this._fadeInDone = false;

        document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().top, 0) + this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--pdp-gallery-top', `${this.headerHeight + 16}px`);

        if (this.isOverlay) {
          document.body.classList.add('header-overlay');
        }

        // Small fix to keep the dropdown in the right place after scrolling back to the top
        this.header.addEventListener('animationend', (e) => {
          if (e.animationName === 'fadeIn') {
            this.header.classList.remove('animate-fadeIn');
            this._fadeInDone = true;
          }
        });

        window.addEventListener('resize', () => {
          this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
          document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().top, 0) + this.header.offsetHeight}px`);
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        });

        window.addEventListener('scroll', () => {
          if (this.isOverlay) {
            this.header.classList.toggle('header--scrolled', window.scrollY > 10);
          }

          if ((window.scrollY > this.lastScroll) && (window.scrollY > (this.headerHeight * 2))) {
            this.header.classList.remove('animate-fadeIn');
            this.header.classList.add('animate-fadeOut');
            this._fadeInDone = false;
            document.documentElement.style.setProperty('--pdp-gallery-top', '20px');
          } else if ((window.scrollY < this.lastScroll) || ((window.scrollY < (this.headerHeight * 2) && this.classList.contains('animate-fadeOut')))) {
            this.header.classList.remove('animate-fadeOut');
            if (!this._fadeInDone) {
              this.header.classList.add('animate-fadeIn');
            }
            document.documentElement.style.setProperty('--pdp-gallery-top', `${this.headerHeight + 16}px`);
          }

          document.documentElement.style.setProperty('--header-offset', `${Math.max(this.header.getBoundingClientRect().top, 0) + this.header.offsetHeight}px`);

          this.lastScroll = window.scrollY;
        }, { passive: true });
      }
    }
  )
}
